module.exports = __webpack_public_path__ + "img/logo_cima.f3c69413.png";